import { ExploreLink, SignUpButton, StoreButtons } from "./Buttons";

export const Hero = () => (
  <section class="px-4 pt-14 pb-10 md:pt-24 md:pb-16 text-center">
    <div class="max-w-3xl mx-auto">
      <p class="text-sm font-semibold uppercase tracking-widest text-purple-600 dark:text-purple-400">Concise audio articles</p>
      <h1 class="mt-4 text-4xl md:text-6xl font-extrabold tracking-tight leading-tight text-gray-900 dark:text-gray-50">Something interesting, in minutes.</h1>
      <p class="mt-6 text-lg md:text-xl text-gray-600 dark:text-gray-300">
        Clear, friendly articles on the things that make life more interesting. Read them, or simply press play. Four to nine minutes each.
      </p>
      <div class="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
        <ExploreLink href="/articles" label="Start reading" testId="landing-hero-explore" />
        <SignUpButton label="Create a free account" testId="landing-hero-sign-up" />
      </div>
      <p class="mt-5 text-sm font-medium text-gray-700 dark:text-gray-200">Free forever. Unlimited articles, no paywall, no catch.</p>
      <p class="mt-8 mb-3 text-sm text-gray-500 dark:text-gray-400">Or take it with you</p>
      <StoreButtons testId="landing-hero" />
    </div>
  </section>
);
